import './Lego.scss'
import React from 'react'
import { connect } from 'react-redux'
import Modules from './editor/Modules/Modules'
import Preview from './editor/Preview/Preview'
import ModulConfigs from './editor/Configs/ModulConfigs'
import { withRouter, RouteProps } from 'react-router-dom'
import { SaveOutlined } from '@ant-design/icons'
import { message, Button, Spin, Modal } from 'antd'
import { setRoot, setUpdate, setBaseInfo, resetPanes, getTemplate } from '../../store/actions'
import legoService from '../../services/lego'
import DeeplinkForm from '@modules/DeepLinkForm'
import { withTranslation } from 'react-i18next'
import { generateContentWithVersion, serializeContentToView } from '@/utils/lego'
import { getUserName } from '@/utils/session'
const mapDispatchToProps = dispatch => ({
  setBase: root => {
    dispatch(setRoot(root))
  },
  isUpdate: isupdate => {
    dispatch(setUpdate(isupdate))
  },
  setLink: link => {
    dispatch(setBaseInfo('link', link))
  },
  setPanes: () => {
    dispatch(resetPanes())
  },
  getTemList: () => {
    dispatch(getTemplate())
  },
})
const mapStateToProps = state => ({
  base: state.tree,
  templateList: state.common.templateList,
})
class LegoPageEditor extends React.Component<RouteProps & any> {
  state = {
    saveLoading: false,
    isUpdate: true,
    visible: false,
  }

  componentDidMount() {
    //引入 lego-components，存入store
    // 初始化panes
    this.props.setPanes()
    this.props.getTemList()

    const stateId = this.props.location.state && this.props.location.state.id
    const paramsId = this.props.match.params && this.props.match.params.id
    if (stateId || paramsId) {
      this.getInfo(stateId || paramsId)
    }
    this.setState({
      isUpdate: paramsId ? true : false,
    })
  }

  saveInfo = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { base, templateList, match } = this.props
    const { isUpdate } = this.state
    const config = base.root.config
    if (config.categoryIds) {
      config.categoryIds = config.categoryIds.split
        ? config.categoryIds.split(',')
        : config.categoryIds
      const proKey = Object.keys(base).find(com => com.startsWith('ProductList'))
      const proCom = proKey ? base[proKey] : {}
      if (proCom?.config?.products && proCom?.config?.products[0]) {
        config.images = proCom?.config?.products[0]?.product?.images[0] || []
      } else {
        config.images = []
      }
    }
    if (
      !config.pageId ||
      !config.shareDes ||
      !config.shareImg ||
      !config.shareTit ||
      !config.merchantId ||
      !config.templateVersion
    ) {
      message.error(this.props.t('fillPageInfo'))
      return
    }
    this.setState({
      saveLoading: true,
    })
    if (isUpdate) {
      legoService
        .updateWebInfo({
          title: base?.root?.config?.title,
          content: generateContentWithVersion(base),
          template: `lego/archVersion/${config.templateVersion || templateList[0]}/index.html`,
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then(res => {
          message.success(this.props.t('updateSuccess'))
          this.setState({
            saveLoading: false,
          })
        })
        .catch(err => {
          message.error(err?.response?.data?.error || err.message)
          this.setState({
            saveLoading: false,
          })
        })
    } else {
      const data = {
        page_id: base.root.config.pageId,
        title: base.root.config.title,
        template: `lego/archVersion/${config.templateVersion}/index.html`,
        content: generateContentWithVersion(base),
        author: getUserName(),
        bucket: config.bucket || '',
        domain: config.domain || '',
      }
      legoService
        .saveWebInfo(data)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        .then(res => {
          message.success(this.props.t('saveSuccess'))
          this.props.history.goBack()
          this.setState({
            isUpdate: true,
            saveLoading: false,
          })
        })
        .catch(err => {
          message.error(err?.response?.data?.error || err.message)
          this.setState({
            saveLoading: false,
          })
        })
    }
  }
  getInfo = (id: string) => {
    const hide = message.loading(this.props.t('pageLoading'), 0)
    legoService
      .getWebInfo(id)
      .then(res => {
        if (res.data && res.data.pages && res.data.pages.length > 0) {
          legoService
            .getWebContent(res.data.pages[0].content)
            .then(result => {
              serializeContentToView(result.data).then(content => {
                this.props.setBase(content)
                this.props.isUpdate(true)
                this.props.setLink(res.data.pages[0].link)
                hide()
              })
            })
            .catch(error => {
              console.log(error)
              hide()
              message.error(error.message)
            })
        }
      })
      .catch(err => {
        console.log(err)
        hide()
        message.error(err.message)
      })
  }
  closeModal = () => {
    this.setState({
      visible: false,
    })
  }
  showDeeplink = () => {
    this.setState({
      visible: true,
    })
  }
  render() {
    const { saveLoading, visible } = this.state
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { base } = this.props
    return (
      <Spin spinning={saveLoading} className="spin_container">
        <div className="admin_container">
          <div className="modules">
            <Modules />
          </div>
          <div className="preview">
            <Preview />
          </div>
          <div className="configs">
            <ModulConfigs />
            <Button
              id="float-save"
              icon={<SaveOutlined />}
              loading={saveLoading}
              onClick={this.saveInfo}
            ></Button>
          </div>
        </div>
        <div className="formBtn" onClick={this.showDeeplink}>
          deeplink
        </div>
        <Modal
          width={800}
          zIndex={1001}
          title="Deep link生成"
          visible={visible}
          onOk={this.closeModal}
          maskClosable={false}
          onCancel={this.closeModal}
        >
          <DeeplinkForm></DeeplinkForm>
        </Modal>
      </Spin>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(LegoPageEditor)))
